import React from "react";
import DataTable from "core/ui/data-table";
import { Link, useHistory } from 'react-router-dom';
import FormatDateTime from "core/utils/FormatDateTime";
import { Button } from "reactstrap";

const table_columns = [
  { header: 'Username', key: 'email' },
  { header: 'First Name', key: 'first_name' },
  { header: 'Last Name', key: 'last_name' },
  { header: 'User Role', key: 'role_name' },
  { header: 'Disabled', key: 'is_disabled', render: (value) => (value.is_disabled ? 'Y' : 'N') },
  { header: 'Access List', key: 'access_list' },
  { header: 'Date Created', key: 'created_date', render: (value) => <FormatDateTime date={value.created_date} /> },
  { header: 'Last Login', key: 'last_login_date', render: (value) => <FormatDateTime date={value.last_login_date} /> },
];

const Users = () => {
  const history = useHistory();

  const onClickNew = (ev) => {
    ev.stopPropagation();
    history.push('/admin-user-form');
  };

  const table_actions = (user) => (
    <ul id="action-menu" className="action-menu">
      <Link to={`/admin-user-form#user_id=${user.id}`}>
        <i className="bi bi-pencil"></i>Edit
      </Link>
    </ul>
  );

  return (
    <div className="page admin-page">
      <div className="list-header sticky-page-header">
        <Link to={"/admin"}>
          <button className="new-button">
            <i className="bi bi-chevron-left"></i> Admin
          </button>
        </Link>
        <h1>Users</h1>
        <i className="spacer" />
        <Button className="new-button" onClick={onClickNew}>New User</Button>
      </div>
      <div className="users">
        <DataTable
          query="users/list"
          cols={table_columns}
          actions={table_actions}
          empty="No Users Found"
        />
      </div>
    </div>
  );
};

export default Users;